import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import GreyHeader from '../../../../shared/ui/GreyHeader'
import CustomButton from '../../component/CustomButton'
import MainTabs from '../../component/dump/MainTabs'
import DriversPage from './DriversPage'
import DriversScoring from './DriversScoring'
import DriversCoaching from './DriversCoaching'
import UnknownDriverTrips from './UnknownDriverTrips'
import DebugSnapshots from './DebugSnapshots'

const DriversContainer = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'driversPage.driversContainer' });
	const { location, user, isUsingDriverFaceID } = props;
	const userRole = user.roles[0];

	const getInitialTab = () => {
		if (sessionStorage.getItem("unknownDriversState")) {
			return 4;
		}
		return 1;
	};

	const [tabKey, setTabKey] = useState(getInitialTab);

	const isProd = location.hostname === 'fleet.roscolive.com';

	const handleNavigation = (tabKey) => {
		setTabKey(tabKey);
	}

	return (
		<div className="drivers-page">
			<GreyHeader
				title={t('titleDrivers')}
			/>

			<MainTabs>
				<CustomButton variant='tab' active={tabKey === 1} onClick={() => handleNavigation(1)}>
					{t('btnAtAGlance')}
				</CustomButton>
				<CustomButton variant='tab' active={tabKey === 2} onClick={() => handleNavigation(2)}>
					{t('btnScoring')}
				</CustomButton>
				<CustomButton variant='tab' active={tabKey === 3} onClick={() => handleNavigation(3)}>
					{t('btnCoaching')}
				</CustomButton>
				{!['partner_view', 'sales_demo'].includes(userRole) &&
					<CustomButton variant='tab' active={tabKey === 4} onClick={() => handleNavigation(4)}>
						{t('btnUnknownDrivers')}
					</CustomButton>
				}
				{!isProd &&
					<CustomButton variant='tab' active={tabKey === 5} onClick={() => handleNavigation(5)}>
						{t('btnDebugSnapshots')}
					</CustomButton>
				}
			</MainTabs>

			{tabKey === 1 &&
				<DriversPage
					location={location}
					isUsingDriverFaceID={isUsingDriverFaceID}
				/>
			}
			{tabKey === 2 &&
				<DriversScoring />
			}
			{tabKey === 3 &&
				<DriversCoaching />
			}
			{tabKey === 4 &&
				<UnknownDriverTrips
					location={location}
					isUsingDriverFaceID={isUsingDriverFaceID}
				/>
			}
			{tabKey === 5 &&
				<DebugSnapshots />
			}
		</div>
	);
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
	}),
)(DriversContainer);
